module.exports = __webpack_public_path__ + "static/img/qybj_04.8bda52f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equity/qybj_04.jpg
// module id = mILw
// module chunks = 0